export default "__VITE_ASSET__RRjocncW__"